/**
 * Shared card-code regex for detecting Ultraman card numbers in text.
 *
 * Matches patterns like:
 *   BP01-064, SD02-003, ST01-012, AP03-001, PR01-005, PR-085
 *
 * The set-number digits are optional (\d{0,2}) so promo cards
 * like PR-085 (no two-digit set number) are also caught.
 *
 * Usage:
 *   import { CARD_CODE_REGEX, extractCardCodes } from '../utils/cardCodes';
 */

// Global regex – remember to reset lastIndex before reuse or use extractCardCodes()
export const CARD_CODE_REGEX = /\b([A-Z]{2,4}\d{0,2}-\d{3})\b/g;

/**
 * Extract all unique card codes from a string.
 * @param {string} text
 * @returns {string[]} deduplicated card codes
 */
export function extractCardCodes(text) {
  if (!text || typeof text !== 'string') return [];
  const codes = new Set();
  let m;
  const re = /\b([A-Z]{2,4}\d{0,2}-\d{3})\b/g;
  while ((m = re.exec(text)) !== null) {
    codes.add(m[1]);
  }
  return Array.from(codes);
}
